"use client"

import { useEffect, type RefObject } from "react"

// A pan-y element with nothing to scroll never becomes the scroll target, so the gesture
// falls through to the page and overscroll-behavior has no scroll of its own to contain.
export const useContainedScroll = (ref: RefObject<HTMLElement | null>, active: boolean) => {
  useEffect(() => {
    const node = ref.current
    if (!active || !node) return
    const hold = (event: TouchEvent) => {
      if (node.scrollHeight <= node.clientHeight) event.preventDefault()
    }
    node.addEventListener("touchmove", hold, { passive: false })
    return () => node.removeEventListener("touchmove", hold)
  }, [ref, active])
}
